import { MessageInterface } from '../../..';

export class MessageDto implements MessageInterface {
  id?: string;
  text?: string;
  createdAt?: Date;
  fromPartnerId?: string;
}
